import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 980px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    margin-left: 15px;
    max-height: 55px;
    max-width: 160px;
    cursor: pointer;
  }

  @media (max-width: 900px) {
    img {
      margin-left: 0px;
      max-height: 55px;
      max-width: 110px;
      cursor: pointer;
    }
  }
`;

export const Main = styled.div`
  padding: 18px 12px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  background: #FFF;
  /* background: ${props => props.primaryColor || '#36397a'}; */
`;
